import { createResource } from '../utils/resource'

const certificateStore = createResource('certificate', {})

export default certificateStore
